<template>
    <div class="vc-flex">
        <span class="title" :style="{'min-width':titleWidth}">{{name}}</span>
        <input spellcheck="false" class="minput" v-model="inputValue" type="text" @focus="getFocus" @blur="changeValue" @keyup.enter="handleEnter" ref="input" />
        <div @click="fastSetValue(item)" class="ops focus-s" :style="{'width':optionWidth}" v-for="item in options" :key="item">{{item}}</div>
    </div>
  </template>
  
  <script>
  import stringHelper from '@/commom/string/StringHelper.js'
  export default {
    name: 'NumberOptionField',
    components:{
        
    },
    props:{
        value:Number,
        name:String,
        options:Array,
        optionWidth:{
            type:String,
            default:'50px'
        },
        titleWidth:{
          type:String,
          default:"150px"
        }
    },
    watch:{
      value:function(nval,old){
        this.inputValue = nval.toString()
      }
    },
    data(){
        return {
            inputValue:this.value.toString()
        }
    },
    methods:{
        ///回车键
        handleEnter:function(){
            
            this.$refs.input.blur();
        },
        ///获得输入焦点
        getFocus:function(event){
            event.target.select();
        },
        ///改变值
        changeValue:function(){
            
            var val = stringHelper.getNumber(this.inputValue.toString())
            //console.log("输出结果=",val)
            this.$emit("changeValue",val)
        },
        ///快速设置值
        fastSetValue:function(item){
            var val = stringHelper.getNumber(item)
            this.inputValue = val
            this.$emit("changeValue",val)
        }
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  .title{
    color: var(--ek-text-color2);
    font-size: 14px;
    display: inline-block;
    min-width: 150px;
  }
  .minput{
    height: 35px;
    outline: none;
    border: none;
    background: var(--ek-input-backColor);
    border-radius: 5px;
    font-size: 14px;
    width: 60px;
    color: var(--ek-text-color1);
    text-align: center;
    margin-right: 20px;
  }
  .ops{
    width: 50px;
    text-align: center;
    background: var(--ek-card-color2);
    line-height: 35px;
    border-radius: 5px;
    color: var(--ek-text-color2);
    margin-right: 10px;
    font-size: 14px;
  }
  </style>